import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

// Layout
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductPage from './pages/ProductPage';
import CategoryPage from './pages/CategoryPage';
import BrandPage from './pages/BrandPage';
import BrandCatalogPage from './pages/BrandCatalogPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DownloadCatalogPage from './pages/DownloadCatalogPage';
import ThankYouPage from './pages/ThankYouPage';
import FAQPage from './pages/FAQPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';

// Admin
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminCategories from './components/admin/AdminCategories';
import AdminBrands from './components/admin/AdminBrands';
import AdminProducts from './components/admin/AdminProducts';
import AdminLeads from './components/admin/AdminLeads';
import AdminBlogs from './components/admin/AdminBlogs';
import AdminFAQs from './components/admin/AdminFAQs';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/all-products" element={<Navigate to="/products" replace />} />
            <Route path="/category/:categorySlug" element={<CategoryPage />} />
            <Route path="/category/:categorySlug/brand/:brandSlug" element={<BrandPage />} />
            <Route path="/brand/:brandSlug" element={<BrandCatalogPage />} />
            <Route path="/product/:productSlug" element={<ProductPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/download-catalog" element={<DownloadCatalogPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="brands" element={<AdminBrands />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="faqs" element={<AdminFAQs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
